import { CheckSquare } from 'lucide-react'

import { RubricInlineCriteriaList } from '@/components/admin/evaluation-rubrics/rubric-inline-criteria-list'
import { rubricSectionHighlight } from '@/components/admin/evaluation-rubrics/rubric-section-ids'
import { EntityManageSection } from '@/components/ui/entity-manage-section'
import { type RubricCriterion } from '@/hooks/use-evaluation-rubrics-admin'

type RubricRequirementsSectionProps = {
  criteria: RubricCriterion[]
  highlighted?: boolean
  onChange: (criteria: RubricCriterion[]) => void
  onEditAdvanced: () => void
  defaultOpen?: boolean
}

export function RubricRequirementsSection({
  criteria,
  highlighted,
  onChange,
  onEditAdvanced,
  defaultOpen = false,
}: RubricRequirementsSectionProps) {
  return (
    <div id={rubricSectionHighlight('requirements')}>
      <EntityManageSection
        title="Requirements"
        subtitle="Pass/fail checks that must be met or flagged when missing"
        leadingIcon={CheckSquare}
        onEdit={onEditAdvanced}
        editAriaLabel="Advanced requirement settings"
        editTitle="Advanced (stable keys)"
        highlighted={highlighted}
        agentHighlight={rubricSectionHighlight('requirements')}
        collapsible
        defaultOpen={defaultOpen}
      >
        <RubricInlineCriteriaList
          criteria={criteria}
          kind="requirement"
          onChange={onChange}
        />
      </EntityManageSection>
    </div>
  )
}
